"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_redux_1 = require("react-redux");
var SimpleNoWrap_1 = __importDefault(require("atomicComponents/atoms/Text/SimpleNoWrap"));
var StatusBadge_1 = __importDefault(require("atomicComponents/molecules/Badge/StatusBadge"));
var LinkCopier_1 = __importDefault(require("atomicComponents/organisms/LinkCopier"));
var DoubleCell_1 = __importDefault(require("containers/TableMaker/components/DoubleCell"));
var single_1 = require("utils/selectors/single");
var constants_1 = require("../../constants");
var utils_1 = require("../utils");
var AgreementStatus = function (_a) {
    var item = _a.item;
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var dateStr = (0, utils_1.getAgreementDateStr)(item);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [dateStr
                ? ((0, jsx_runtime_1.jsx)(Box_1.default, __assign({ overflow: "hidden", flexGrow: 1 }, { children: (0, jsx_runtime_1.jsx)(DoubleCell_1.default, { main: ((0, jsx_runtime_1.jsx)(SimpleNoWrap_1.default, { children: (0, jsx_runtime_1.jsx)(StatusBadge_1.default, { mapper: constants_1.AGREEMENT_STATUS_MAPPER, status: (0, end2end_1.getCustomerExtendedAgreementStatus)(item), display: "inline" }) })), secondary: (0, jsx_runtime_1.jsx)(Box_1.default, __assign({ pl: 3.125, component: SimpleNoWrap_1.default }, { children: dateStr })) }) })))
                : ((0, jsx_runtime_1.jsx)(StatusBadge_1.default, { mapper: constants_1.AGREEMENT_STATUS_MAPPER, status: (0, end2end_1.getCustomerExtendedAgreementStatus)(item), position: "relative", flexGrow: 1 })), item.publicId && ((0, jsx_runtime_1.jsx)(Box_1.default, __assign({ pl: 1, pb: 0.5, className: "showOnHover displayOnHover" }, { children: (0, jsx_runtime_1.jsx)(LinkCopier_1.default, { text: (0, end2end_1.getCustomerAgreementUrl)(item, !profile.isAdmin ? 'cl' : undefined), buttonLabelCopy: "Copy link", hideText: true }) })))] }));
};
exports.default = AgreementStatus;
